import React, { useState } from 'react';
import { Icon } from '../../Icon';
import { FormField, ResultCard } from './shared';

const SlugGenerator = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [text, setText] = useState('');
  const [slug, setSlug] = useState('');

  const generate = () => {
    const s = text.toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-+|-+$/g, '');
    setSlug(s);
    onResultChange([{ label: 'Slug', value: s }]);
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-8 rounded-3xl shadow-lg border border-theme-border">
        <FormField label="Texto" value={text} onChange={setText} type="textarea" placeholder="Título do artigo..." />
        <div className="flex justify-center my-6">
          <button onClick={generate} className="px-10 py-4 bg-accent-gradient text-white rounded-xl font-bold flex items-center gap-2"><Icon name="refresh" className="w-5 h-5" /> Gerar Slug</button>
        </div>
        {slug && (
          <div className="p-4 bg-theme-input rounded-xl border border-theme-border font-mono text-center flex justify-between items-center">
            <span className="break-all">{slug}</span>
            <button onClick={() => navigator.clipboard.writeText(slug)} className="text-xs text-indigo-600 font-bold ml-4">Copiar</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SlugGenerator;
